import {AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output,} from '@angular/core';

import {ProjectStatusModel} from '../../project-status/project.status.model';
import {SuppliersService} from '../../../../services/suppliers.service';
import {MatDialog} from '@angular/material/dialog';
import {ChangedOverlayComponent} from '../../overlays/changed-overlay/changed.overlay.component';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {FileResponse} from '../../../../models/file.response';
import {saveAs} from 'file-saver';

import {
  UploadToolacceptanceReportComponent
} from './upload-tool-acceptance-report/upload-toolacceptance-report.component';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {TranslateService} from '@ngx-translate/core';
import {CoreService, DocumentService, Param, ProleisObject} from "@proleis/proleis-rest-client";
import {CurrentViewService, LoadingService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-position-bm-card',
  templateUrl: 'position.card.bm.component.html',
  styleUrls: ['position.card.bm.component.scss'],
})
export class PositionCardBmComponent implements OnInit, AfterViewInit {
  @Input()
  pos: ProleisObject;

  @Input()
  pbo: ProleisObject;
  changed: boolean;

  @Output()
  checkChangedEvent = new EventEmitter<boolean>();

  constructor(
    private coreService: CoreService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private currentViewService: CurrentViewService,
    public suppliersService: SuppliersService,
    private dialog: MatDialog,
    private documentsService: DocumentService,
    @Inject(APP_GUIDS) private guids: AppGuids,
    private bottomSheet: MatBottomSheet,
    private translationService: TranslateService,
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.changed = this.suppliersService.hasOrderChanged(this.pos);
  }

  insertProjectStatus(id: string) {
    this.loadingService.setBlocking(
      'projektstatus',
      true,
      'Projektstatus wird angelegt...',
    );
    const params: Param[] = [];
    this.coreService
      .executeAction<ProjectStatusModel>(
        id,
        '§b02fe89c-2c51-11b2-8016-cb6d12b1d0f5',
        params,
      )
      .subscribe(
        (result) => {
          this.notificationService.showNotification('Projektstatus angelegt');
          this.loadingService.setBlocking('projektstatus', false, '');
        },
        (error) => {
          this.notificationService.showError(error.error);
          this.loadingService.setBlocking('projektstatus', false, '');
        },
      );
  }

  openChangedDialog() {
    this.dialog
      .open(ChangedOverlayComponent, {
        data: {
          docName: this.pos.DWS_CHANGE_DOCUNAME,
          docId: this.pos.DWS_CHANGE_DOCU_ID,
          posId: this.pos.OBJECT_ID,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        this.changed = !result;
      });
  }

  isInternal(): boolean {
    return this.pbo.CHANNELGUID === this.guids.GUID_CHANNEL_INTERNAL;
  }

  downloadDeliveryNote(pos: ProleisObject) {
    return this.documentsService
      .getDocumentFile(pos.PBO_DELIVERY_DOC_ID)
      .subscribe((response) => {
        const fileResponse: FileResponse = FileResponse.parseResponse(response);
        saveAs(fileResponse.content, fileResponse.fileName);
        this.currentViewService.setLoading(false);
      });
  }

  createBmDelivery() {
    this.suppliersService
      .createBmDelivery(this.pbo, this.pos)
      .subscribe((pos) => (this.pos = pos));
  }

  uploadToolAcceptanceReport() {
    this.bottomSheet
      .open(UploadToolacceptanceReportComponent)
      .afterDismissed()
      .subscribe((result: FileList) => {
        const formData: FormData = new FormData();
        formData.set('file', result.item(0), result.item(0).name);
        this.coreService
          .executeActionFormData(
            this.pos.OBJECT_ID,
            '§' + this.guids.GUID_UPLOAD_WERKZEUGABNAHME_PROTOKOLL_ACTION,
            formData,
            '1474',
          )
          .subscribe((result) => {
            this.notificationService.showNotification(
              this.translationService.instant(
                'orders.positions.bm.wap.success',
              ),
            );
            this.checkChangedEvent.next(true);
          });
      });
  }

  downloadToolAcceptanceReport() {
    this.coreService
      .executeAction<any>(
        this.pos.OBJECT_ID,
        '§' + this.guids.GUID_SCRIPT_PSE_WAP_EXTERN,
      )
      .subscribe((result) => {
        console.log(result);
        this.documentsService
          .getDocumentFile(result.value)
          .subscribe((response) => {
            const fileResponse = FileResponse.parseResponse(response);
            saveAs(fileResponse.content, fileResponse.fileName);
          });
      });
  }
}
